import React, { useCallback } from 'react'

import { Option } from '../../models/Option'

type Props = {
    selected: boolean
    option: Option
    onSelect: (option: Option) => void
}

export const ReportSelectModalCard = ({ selected, option, onSelect }: Props) => {
    const onSelectAction = useCallback(() => {
        if (option.enabled) {
            onSelect(option)
        }
    }, [option, onSelect])

    return (
        <div
            className={`reportSelectModalCard ${selected ? 'selected' : ''} ${!option.enabled ? 'disabled' : ''}`}
            tabIndex={option.enabled ? 0 : -1}
            onClick={onSelectAction}
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    event.stopPropagation()
                    onSelectAction()
                }
            }}
            key={option.id}
        >
            <div className="label">
                <div className="title">{option.label}</div>
                {option.subtitle && <div className="subtitle">{option.subtitle}</div>}
            </div>
            <div className="action">
                <input type="radio" tabIndex={-1} checked={selected} disabled={!option.enabled} />
            </div>
        </div>
    )
}
